export default __webpack_public_path__ + "static/media/SK.98b83b9b.svg";